import { Component, type ErrorInfo, type PropsWithChildren } from 'preact/compat';

import { isAxiosError } from 'axios';

import { ErrorLogger } from '@/shared/service/logger/ErrorLogger';

import { ErrorPage } from '@/widget/error-page/ui';

interface State {
  hasError: boolean;
  errorType?: 'axios' | 'unknown';
}

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(): State {
    return { hasError: true, errorType: 'unknown' };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({
      hasError: true,
      errorType: isAxiosError(error) ? 'axios' : 'unknown',
    });

    void ErrorLogger.error(error, info.componentStack ?? error.message);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}
